<script>
import {assign} from 'lodash-es'

export default {
  name: 'fast-field-render',
  props: {
    node: Object,
    rowIndex: Number,
    row: Object
  },
  inject: ['formData', 'subData', 'pageType'],
  computed: {
    curFormData () {
      return this.row || this.formData
    },
    // 对象字符串list
    objectStringList () {
      return this.node.apiName?.split('.') || []
    },
    multipartyBindData () {
      const list = this.objectStringList
      let obj = this.curFormData
      for (let i = 0; i < list.length - 1; i++) {
        obj = obj[list[i]]
      }
      return obj
    },
    inputValue: {
      get () {
        const list = this.objectStringList
        return this.multipartyBindData?.[list[list.length - 1]]
      }
    }
  },
  data () {
    return {
      newProps: {
        isPureText: true,
        size: 'mini',
        styleType: 'mini',
        follow: true
      }
    }
  },
  created () {
    this.className = `is-pure-text field field-mini ${this.newProps?.className || ''}`
    const {props, propsFn} = this.node
    // 因为每行propsFn返回值不一样 不能直接修改node.props
    let _props = {
      ...props,
      id: this.curFormData?.['aPaaS_SequenceId'],
      size: 'mini',
      styleType: 'mini',
      row: this.curFormData,
      follow: true
    }

    if (typeof propsFn === 'function') {
      assign(
        _props,
        propsFn.call(this, {
          field: this.node,
          formData: this.formData,
          row: this.curFormData,
          rowIndex: this.rowIndex
        })
      )
    }
    this.$set(this, 'newProps', _props)
  },
  methods: {
    contentSlots (h) {
    /*eslint-disable*/
    const Component = this.node.fieldComponentName
    const contentSlots = this.slotsHandle(h, 'content')
    return this.getSlotsFn('content')
      ? contentSlots
      : <Component
        v-model={this.inputValue}
        props={{...this.newProps}}
        attrs={{...this.newProps}}
     />
  },
    getSlotsFn (position) {
      const {slots} = this.node
      return slots?.[position]
    },
    slotsHandle (h, position) {
      const Fn = this.getSlotsFn(position)
      if (Fn) {
        return Fn(h, {
          field: this.node,
          formData: this.formData,
          row: this.row,
          rowIndex: this.rowIndex
        })
      }
      return null
    }
  },
  render (h) {
    if (!this.newProps.pageShow) {
      return null
    }
    const {className} = this
    const contentSlots = this.contentSlots(h)
    const temp = [
      this.slotsHandle(h, 'before'),
      <div class={className}>{contentSlots}</div>,
      this.slotsHandle(h, 'after')
    ]
    return (this.getSlotsFn('content') && !contentSlots
        ? null : <sy-form-item props={{ follow: true, styleType: 'mini', label: this.newProps.label, hideLabel: this.newProps.hideLabel  }}>{temp}</sy-form-item>)
  }
}
</script>
<style scoped lang='scss'>
::v-deep {
  input.el-input__inner::-webkit-input-placeholder {
    color: #BFC7E0 !important;
  }

  input.el-input__inner {
    border-color: #EDEFF4 !important;
    border-radius: 2px;
  }

  .field {
    color: #2E3656;
    word-break: break-all;
    &.field-mini.is-pure-text {
      padding-top: 8px;
      font-size: 12px;
    }

    &.is-pure-text {
      padding-top: 6px;
      font-size: 14px;
    }
    
  }

  .el-select {
    width: 100%;
  }
}
::v-deep .sy-accessory-mini {
  overflow: visible;
}
::v-deep .edit-address-wrap{
  padding-top: 6px;
}
::v-deep .file-empty{
  padding-top: 8px;
  display: inline-block;
}
// 上下结构覆盖padding样式
.sy-form-item--top{
  ::v-deep .field.is-pure-text{
    padding-top: 0;
  }
}
</style>
